import { useContext } from 'react';
import { UserInfoContext } from '../contexts/UserInfoContext';

const useAuthUsers = () => useContext(UserInfoContext);

export default useAuthUsers;
